import axios from 'axios';

const API_URL = !window.location.href.includes('test') && !window.location.href.includes('localhost') ? 'https://api.glassen-it.com/component/socparser' : 'https://api.glassen-it.com/component/socparser';

export default axios.create({
  baseURL: API_URL,
  headers: {
    accept: '*/*',
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    Authorization: `Bearer ${localStorage.getItem("access")}`,
  },
  withCredentials: true,
});

